import type { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import useTheme from '@mui/material/styles/useTheme';
import { useAnchorMenu } from '../../hooks';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Link } from 'react-router-dom';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import DescriptionIcon from '@mui/icons-material/Description';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { USER_GUIDE_CONF_LINK, WIMAS_CONF_LINK } from '../../constants';
const Item = ({
  to,
  title,
  icon,
  onClose,
  description,
  descriptionStyle = 'primary',
}: {
  to: string;
  title: string;
  icon: ReactNode;
  description: string;
  descriptionStyle?: 'primary' | 'error';
  onClose?: () => void;
}) => {
  const t = useTheme();
  return (
    <MenuItem onClick={onClose}>
      <Link
        target="_blank"
        to={to}
        style={{
          display: 'flex',
          alignItems: 'center',
          textDecoration: 'none',
          paddingTop: 2,
          paddingBottom: 2,
          width: '100%',
        }}
      >
        <ListItemIcon sx={{ mr: 2 }}>{icon}</ListItemIcon>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          <Typography sx={{ fontSize: '0.875rem', color: 'black' }}>{title}</Typography>
          <Typography
            sx={{
              fontSize: '0.875rem',
              color: descriptionStyle === 'primary' ? t.palette.primary.main : t.palette.emergency.main,
            }}
          >
            {description}
          </Typography>
        </Box>
      </Link>
    </MenuItem>
  );
};

const HelpNav = () => {
  const { isOpen, anchor, handleOpenMenu, handleCloseMenu } = useAnchorMenu();

  return (
    <>
      <Button
        sx={(t) => ({ color: t.palette.text.secondary })}
        id="settings-item-button"
        aria-controls={isOpen ? 'settings-item-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={isOpen ? 'true' : undefined}
        variant="text"
        disableElevation
        disableRipple
        disableTouchRipple
        onClick={handleOpenMenu}
      >
        <HelpOutlineIcon sx={{ fontSize: 24 }} />
      </Button>
      <Menu
        sx={{ list: { p: 0 } }}
        id="settings-item-menu"
        slotProps={{
          paper: {
            sx: {
              width: 220,
            },
          },
        }}
        elevation={8}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        anchorEl={anchor}
        open={isOpen}
        onClose={handleCloseMenu}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', px: 1.5, py: 1, background: 'rgba(41, 121, 255, 0.08)' }}>
          <SupportAgentIcon sx={(t) => ({ fontSize: 28, color: t.palette.primary.main, mr: 2 })} />
          <Typography sx={(t) => ({ fontSize: '0.95rem', color: t.palette.primary.main })}>
            Wellpilot support
          </Typography>
        </Box>
        <Item
          title="Documentation"
          icon={<DescriptionIcon sx={{ DescriptionIcon: 28 }} />}
          to={USER_GUIDE_CONF_LINK}
          description="Before reporting in Slack"
        />
        <Item
          title="Report in WIMAS"
          icon={<WarningAmberIcon sx={{ DescriptionIcon: 28 }} />}
          to={WIMAS_CONF_LINK}
          description="For critical issues"
          descriptionStyle="error"
        />
      </Menu>
    </>
  );
};

export default HelpNav;
